export const SET_PAGE_DATA = "SET_PAGE_DATA";

export const setPageDataAction = (data) => ({
  type: SET_PAGE_DATA,
  payload: data,
});
